import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import { Store } from '@ngrx/store';
import moment from "moment";
import { AppSettingsDto } from '../../services/api.services';
import { SettingsDrivenPipeOverride } from "./settings-driven-pipe-override";

@Pipe({
  name: 'dateWithTimezone',
  pure: false,
  standalone: false
})
export class DateWithTimezonePipe extends SettingsDrivenPipeOverride<DatePipe> implements PipeTransform {
  protected getPipe() {
    return new DatePipe(this.pipeLocale);
  }

  protected onTransform(pipe: DatePipe, settings: AppSettingsDto, value: any, format?: string, timezone?: string, locale?: string)
  protected onTransform(pipe: DatePipe, settings: AppSettingsDto, value: any, format?: string, timezone?: TimezoneSettings, locale?: string)
  protected onTransform(pipe: DatePipe, settings: AppSettingsDto, value: any, format?: string, timezone?: any, locale?: string) {
    let _timezoneSettings: TimezoneSettings = null;

    if (timezone && typeof timezone == "string")
      _timezoneSettings = { offset: timezone };

    if (timezone && typeof timezone == "object")
      _timezoneSettings = timezone;

    let formatString: string = this.localisationService.CUSTOM_DATE_FORMATS[format] || format;

    const locale_ = locale ?? settings.locale ?? this.pipeLocale;

    const timezoneIana_ = _timezoneSettings?.iana ?? settings.timeZoneIana;
    const timezoneOffset = _timezoneSettings?.offset ?? moment.tz(_timezoneSettings?.dstDate ?? value, timezoneIana_).format('Z');

    if (locale_.toLowerCase() === 'ja-JP'.toLowerCase()) {
      formatString = this.localisationService.mapToJapaneseFormat(formatString);
    }

    const formattedDateTime = pipe.transform(value, formatString, timezoneOffset, locale_);
    const timezoneString = this.getTimeZoneAbbreviation(_timezoneSettings?.dstDate ?? value, timezoneIana_);

    return value ? `${formattedDateTime} ${timezoneString}` : '';
  }

  getTimeZoneAbbreviation(date: any, timezone: string) {
    const abbrv = moment.tz(date, timezone).zoneAbbr();
    const offset = moment.tz(date, timezone).format('Z');

    if (isOffsetString(abbrv)) {
      return `(UTC${offset})`
    }

    return `(UTC${offset}) ${abbrv}`;

    function isOffsetString(str: string) {
      return /^[-+]?[0-9]+/.test(str);
    }
  }
}

export interface TimezoneSettings {
  offset?: string,
  iana?: string,
  dstDate?: any
}
